<script lang="ts" setup>
interface Props {
  title: string
  body?: string
  actionLabel?: string
  actionTo?: string
  closeToast?: () => void
  onActionClick?: () => void
}

const props = defineProps<Props>()

async function onAction(): Promise<void> {
  if (!props.actionTo)
    return
  props.onActionClick?.()
  props.closeToast?.()
  window.open(props.actionTo, '_blank', 'noopener,noreferrer')
}
</script>

<template>
  <div class="user-inbox-toast">
    <div class="user-inbox-toast__title rb-mask">
      {{ title }}
    </div>
    <div v-if="body" class="user-inbox-toast__body rb-mask">
      {{ body }}
    </div>
    <button
      v-if="actionLabel && actionTo"
      type="button"
      class="user-inbox-toast__action"
      @click.stop.prevent="onAction"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<style scoped>
.user-inbox-toast__title {
  margin-bottom: 4px;
  font-weight: 700;
}

.user-inbox-toast__body {
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.3;
  white-space: pre-line;
}

.user-inbox-toast__action {
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 0;
  font-weight: 700;
  text-decoration: underline;
  color: inherit;
}
</style>
